<template>
  <div>
    <div class="hos_table" v-loading="loading">
      <p class="p_text">在线考试</p>
      <div class="_table">
        <el-table
          ref="tabledata"
          :data="getData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (pageIndex - 1) * eachPageNum }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150px"
            label-height="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button
                  type="text"
                  size="small"
                  :disabled="buttontypes(scope.row)"
                  :class="
                    scope.row.IsPublish != 1 && scope.row.isExamed == 1
                      ? 'tes'
                      : ''
                  "
                  @click="buttonType(buttonTxt(scope.row), scope.row)"
                  >{{ buttonTxt(scope.row) }}</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  style="color: red"
                  v-if="cacheType(scope.row) == true"
                  @click="cacheExam(scope.row)"
                  >缓存交卷</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <p>共有{{ total }}条记录，当前第{{ pageIndex }}/{{ pagesun }}页</p>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="eachPageNum"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Popup
      ref="popup"
      :title="title"
      :infoTxt="infoTxt"
      :statePopupstatus="statePopupstatus"
    />
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import Popup from "./Popup.vue";
import loginvuex from "@/store/index";
// import {internalIpV6, internalIpV4} from 'internal-ip';
// import publicIp from 'public-ip';
// import {publicIp, publicIpv4, publicIpv6} from 'public-ip';
export default {
  data() {
    return {
      statePopupstatus: {},
      getData: [],
      ip: null,
      formColumns: [
        {
          prop: "ExamName",
          label: "考试名称",
        },
        {
          prop: "BeginTime1",
          label: "考试时间",
          width: "280px",
        },
        {
          prop: "SpendTime1",
          label: "考试时长",
        },
        {
          prop: "count1",
          label: "参考人数",
        },
        {
          prop: "Score",
          label: "学分",
        },
        {
          prop: "Condition1",
          label: "获取学分条件",
        },
      ],
      pageIndex: 1,
      eachPageNum: 10, //当前也多少条数。
      pagesizesarr: [5, 10, 20, 50, 100],
      showpageindex: 1, //显示的索引盒子
      loading: true,
      total: 100, //总条数
      pagesun: "", //一共多少页,
      title: "温馨提示",
      infoTxt: 0,
      userScoreExam: {}, // 考试成绩
      userID: "",
    };
  },
  components: {
    Popup,
  },
  methods: {
    reload() {
      //刷新主页路由的办法
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNum = val;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.loading = true;
      this.getDatalist();
    },
    // 获取表格
    async getDatalist() {
      let obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        pageIndex: this.pageIndex - 1,
        eachPageNum: this.eachPageNum,
      };
      const { data } = await ksPcApi.getexamList(obj);
      if (data.Status == 200) {
        this.total = data.Data.count;
        this.getData = data.Data.data.map((item) => {
          item.Score = item.Score ? item.Score : "暂无";
          item.getScore = item.getScore ? item.getScore : "暂无";
          if (item.Condition == 1) {
            item.Condition1 = "看过或参加即可获得";
          } else if (item.Condition == 2) {
            item.Condition1 = "完成或及格才可获得";
          } else {
            item.Condition1 = "暂无";
          }
          item.BeginTime1 =
            this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
            "-" +
            this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
          this.$set(item, "SpendTime1", item.SpendTime + "分");
          this.$set(item, "count1", item.count + "人");
          this.$set(item, "timeDiff", "");
          return item;
        });
        this.pagesun = data.Data.pageCount;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.Msg);
      }
    },
    // 查看考试成绩
    async viewDetails(row) {
      this.title =
        "姓名：" + JSON.parse(localStorage.getItem("userlist")).realName;
      this.infoTxt = 0;
      this.statePopupstatus = row;
      let obj = {
        examID: row.ExamID,
        studentUserID: row.UserID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await ksPcApi.getStudentTestResults(obj);
      if (data.Status == 200) {
        this.userScoreExam = data.Data[0];
      } else {
        this.$message.error(data.Msg);
      }
      this.$refs.popup.dialogVisibleObj.textInfo = true;
    },
    // 按钮点击
    buttonType(type, row) {
      if (type == "开始考试") {
        this.$router.push({
          path: "/examination/addExam",
          query: { type: "ks", examID: row.ExamID, paperid: row.PaperID },
        });
      } else if (type == "查看考试成绩") {
        // 此处校验规则 开启自动查看成绩--->  没主观阅题直接查看成绩，有主观阅题需批阅  关闭自动查看，必须全都是批阅才能查看
        if (row.IsPublish != 1 && row.isExamed == 1) {
          // 当前有主观阅题需老师打分才能查看 或则试卷没提交  isExamed 1有答题记录  IsPublish 0未发布成绩 1发布成绩
          this.$alert("试卷尚未批阅，暂不能查看考试成绩", "温馨提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.getDatalist(); // 刷新列表
            },
          });
          // console.log("这里有主观题");
        } else {
          this.viewDetails(row);
          // console.log("这是全是选择题");
        }
      }
    },
    // 缓存交卷
    cacheExam(row) {
      // 缓存交卷的逻辑是考生答题了，未交卷，且考试时间已过
      this.$confirm("确定要从缓存再次交卷吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const sourceData = JSON.parse(
            localStorage.getItem(`sourceData${row.ExamID}_${this.userID}`)
          );
          let userAbswerArr = JSON.parse(
            localStorage.getItem(`userAbswerArr${row.ExamID}_${this.userID}`)
          );
          const passScore = sourceData.PassScore; // 及格分数
          let newArr = userAbswerArr.filter((item) => {
            // 过滤正确得分
            return item.IsRight == true;
          });
          let newAndScore = newArr.map((item) => {
            // 过滤分值
            return item.Score;
          });
          let num = 0;
          for (let i = 0; i < newAndScore.length; i++) {
            num += Number(newAndScore[i]);
          }
          let examJson = userAbswerArr.map((item) => {
            return {
              TestID: item.TestID,
              ChildTableID: item.ChildTableID,
              UserAnswer: item.UserAnswer,
              IsRight: item.IsRight,
            };
          });
          let examobj = {
            Score: num, // 得分
            IsPass: num >= passScore ? 1 : 0, // 是否及格 0 不及格 1及格
            resultExamID: sourceData.ExamResultID,
          };
          let obj = {
            guid: JSON.parse(loginvuex.state.userlist).guid,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            hid: JSON.parse(loginvuex.state.userlist).hid,
            examID: row.ExamID,
            examResultJson: JSON.stringify(examJson),
            examJSON: JSON.stringify(examobj), // 得分
            Model: "normal", // 正常交卷 sys系统收卷 Cut 切屏交卷
          };

          const { data } = await ksPcApi.submitExamResult(obj);
          if (data.Status == 200) {
            this.getDatalist(); // 刷新列表
            localStorage.removeItem(`anIndex${row.ExamID}_${this.userID}`); // 清除用户答题进度
            localStorage.removeItem(
              `userAbswerArr${row.ExamID}_${this.userID}`
            ); // 清除用户答案
            localStorage.removeItem(`sourceData${row.ExamID}_${this.userID}`); // 清除试题数据
            localStorage.removeItem(
              `TestBeginTime${row.ExamID}_${this.userID}`
            ); // 清除试题数据
            this.$message({
              type: "success",
              message: "缓存交卷成功!",
            });
          } else {
            this.$message.error(data.Msg);
          }
        })
        .catch(() => {});
    },
    getLocalIPs(timeout = 3000) {
      return new Promise((resolve, reject) => {
        const ips = [];
        let timer;
        const RTCPeerConnection =
          window.RTCPeerConnection ||
          window.mozRTCPeerConnection ||
          window.webkitRTCPeerConnection;

        if (!RTCPeerConnection) {
          reject(new Error("WebRTC not supported"));
          return;
        }

        const pc = new RTCPeerConnection({ iceServers: [] });

        // 超时处理
        timer = setTimeout(() => {
          cleanup();
          reject(new Error("获取IP地址超时"));
        }, timeout);

        const cleanup = () => {
          clearTimeout(timer);
          pc.onicecandidate = null;
          pc.close();
        };

        pc.createDataChannel("");

        pc.onicecandidate = (e) => {
          console.log(e,'为什么e',ips);
          
          if (!e.candidate) {
            cleanup();
            if (ips.length) {
              resolve([...new Set(ips)]);
            } else {
              reject(new Error("未发现本地IP"));
            }
            return;
          }

          const ipRegex =
            /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
          const ipMatch = e.candidate.candidate.match(ipRegex);

          if (ipMatch) {
            const ip = ipMatch[1];
            if (!ips.includes(ip)) {
              ips.push(ip);
            }
          }
        };

        pc.createOffer()
          .then((offer) => pc.setLocalDescription(offer))
          .catch((err) => {
            cleanup();
            reject(err);
          });
      });
    },
  },
  computed: {
    buttonTxt() {
      return function (type) {
        const time = Date.parse(new Date());
        const BeginTime = Date.parse(type.BeginTime);
        const EndTime = Date.parse(type.EndTime);
        let TestBeginTime = "";
        // let timeDiff = ""; // 得到考试剩余时间
        if (localStorage.getItem(`sourceData${type.ExamID}_${this.userID}`)) {
          let sourceData = JSON.parse(
            localStorage.getItem(`sourceData${type.ExamID}_${this.userID}`)
          );
          let a = localStorage.getItem(
            `TestBeginTime${type.ExamID}_${this.userID}`
          );
          a = a.substring(1, a.length - 1);
          TestBeginTime = this.$moment(a).format("X");
          let time1 = this.$moment().format("X"); // 获取时间戳以秒为单位
          let when = Number(time1) - Number(TestBeginTime); // 得到答题目前用时时间，单位秒
          type.timeDiff = Number(sourceData.SpendTime) * 60 - when; // 负数则表示答题时间已过期
        }
        if (time > EndTime) {
          return "考试结束";
        } else if (
          type.isExamed == 1 &&
          (type.timeDiff < 0 || type.timeDiff == "")
        ) {
          // 有答题记录且答题时长以用完
          return "查看考试成绩";
        } else if (time < BeginTime && EndTime > time) {
          return "待考试";
        } else if (
          (time > BeginTime && time < EndTime) ||
          ((type.timeDiff == "" || type.timeDiff > 0) && type.isExamed == 0)
        ) {
          // 在考试时间范围内，且答题时间还有余且未有答题记录
          return "开始考试";
        }
      };
    },
    buttontypes() {
      return function (type) {
        const time = Date.parse(new Date());
        const BeginTime = Date.parse(type.BeginTime);
        const EndTime = Date.parse(type.EndTime);
        let TestBeginTime = "";
        if (localStorage.getItem(`sourceData${type.ExamID}_${this.userID}`)) {
          let sourceData = JSON.parse(
            localStorage.getItem(`sourceData${type.ExamID}_${this.userID}`)
          );
          let a = localStorage.getItem(
            `TestBeginTime${type.ExamID}_${this.userID}`
          );
          a = a.substring(1, a.length - 1);
          TestBeginTime = this.$moment(a).format("X");
          let time1 = this.$moment().format("X"); // 获取时间戳以秒为单位
          let when = Number(time1) - Number(TestBeginTime); // 得到答题目前用时时间，单位秒
          type.timeDiff = Number(sourceData.SpendTime) * 60 - when; // 负数则表示答题时间已过期
        }
        // console.log(type.ExamName, type.IsPublish, type.isExamed, "------>>");
        if (time > EndTime) {
          // 考试结束禁用
          return true;
        } else if (BeginTime > time && EndTime > time) {
          // 待考试禁用
          return true;
        } else if (
          // isExamed  0 参加考试
          type.IsPublish != 1 &&
          type.isExamed == 1
        ) {
          // 当前有主观阅题需老师打分才能查看 或则试卷没提交
          return false;
        } else {
          return false;
        }
      };
    },
    // 缓存交卷
    cacheType() {
      return function (row) {
        // 用户没有提交试卷，且考试时间已过，本地有缓存
        const time = Date.parse(new Date());
        const EndTime = Date.parse(row.EndTime);
        let TestBeginTime = "";
        let sourceData = null;
        if (localStorage.getItem(`sourceData${row.ExamID}_${this.userID}`)) {
          sourceData = JSON.parse(
            localStorage.getItem(`sourceData${row.ExamID}_${this.userID}`)
          );
          let a = localStorage.getItem(
            `TestBeginTime${row.ExamID}_${this.userID}`
          );
          a = a.substring(1, a.length - 1);
          TestBeginTime = this.$moment(a).format("X");
          let time1 = this.$moment().format("X"); // 获取时间戳以秒为单位
          let when = Number(time1) - Number(TestBeginTime); // 得到答题目前用时时间，单位秒
          row.timeDiff = Number(sourceData.SpendTime) * 60 - when; // 负数则表示答题时间已过期
        }
        // 当前试卷未提交且考试时间剩余时间为空，  当前考试时间结束且没有交卷 此刻有一处不严谨(外加userID条件校验)
        if (
          (sourceData != null &&
            row.ExamID == sourceData.ExamInfo.ExamID &&
            row.timeDiff < 0) ||
          (time > EndTime &&
            sourceData &&
            row.ExamID == sourceData.ExamInfo.ExamID)
        ) {
          return true;
        } else {
          return false;
        }
      };
    },
  },
  async mounted() {
    this.getLocalIPs()
      .then((ips) => console.log("本地IP地址:", ips))
      .catch((err) => console.error("错误:", err.message));
    // console.log( );
    // this.getUserIP()
    //   .then(ip => {
    //     console.log('Local IP:', ip);
    //     // 在这里处理获取到的IP地址
    //   })
    //   .catch(err => {
    //     console.error('Error getting IP:', err);
    // });
  },
  created() {
    this.userID = JSON.parse(loginvuex.state.userlist).userID;
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
.hos_table {
  margin-top: 24px;
  min-height: 560px;
  background: #fff;
  .p_text {
    margin-bottom: 12px;
    background: #f7f7f7;
    color: #666666;
    height: 40px;
    text-align: left;
    padding: 6px 24px;
    font-weight: bold;
  }
  ._table {
    padding: 0px 24px;
  }
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(12) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
.sonbtn {
  border: 1px solid #d9d9d9 !important;
  color: #999999;
}
// 分页
.foot_box {
  position: relative;
  height: 86px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
::v-deep .el-range-separator {
  color: #eeeeee !important;
}
::v-deep .el-table .redtwo .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #aaaaaa !important;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #cce7ff;
  color: #333333;
  opacity: 1;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(12) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}

::v-deep .el-table td div:nth-child(1) {
  text-align: center;
}

.operation_box {
  .el-button {
    font-size: 16px;
  }
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ffa200;
  }
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #00d254;
  }
}
.icon-tishi {
  display: inline-block;
  // transform: translate(-6px, -5px) scale(0.6);
  &::before {
    color: #cad8d0;
    display: inline-block;
  }
}

.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      flex: 1;
      width: 80px;
    }
  }
}
.null_view {
  ::v-deep .el-dialog {
    width: 300px !important;
    min-height: 200px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .delete_mian {
    display: flex;
    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }
}
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    min-height: 188px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .delete_mian {
    display: flex;
    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  button:nth-child(1) {
    margin-right: 50px;
  }
}
::v-deep .el-dialog__footer {
  padding: 0;
}
::v-deep.el-dialog__header {
  padding: 16px 20px 10px;
}
::v-deep .el-dialog__header {
  height: 55px;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  background: linear-gradient(
    180deg,
    #64b5ff 0%,
    rgba(199, 228, 255, 1) 100%
  ) !important;
}
.el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.exportView {
  ::v-deep .el-dialog {
    width: 340px !important;
    height: 220px !important;
    line-height: 24px;
    border-radius: 5px 5px 0px 0px;
  }
}
.batch_box {
  padding: 0px 24px;
  margin-top: 24px;
  .el-button {
    width: 141px;
    height: 40px;
    color: #ffffff;
    background: #64b5ff;
  }
  span > i {
    font-size: 14px !important;
    margin-right: 5px;
  }
}
.tes {
  color: #c0c4cc !important;
}
</style>
